import { render } from "./DetalleTicketView.vue?vue&type=template&id=7b69c930"
import script from "./DetalleTicketView.vue?vue&type=script&lang=js"
export * from "./DetalleTicketView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__